<template>
  <div :class="['input-group',{ 'icon-valid': (validacoes.nome && nome.length > 0) }, { 'icon-error': (!validacoes.nome && nome.length > 0) }]" >
    <input
      id="nome"
      name="nome"
      v-model="nome"
      class="base-input"
      type="text"
      placeholder="Nome completo"
      @input="isNomeValid()"
      @blur="enviaGA()"
      >
  </div>
</template>
<script>
export default {
  data() {
    return {
      nome: '',
      validacoes: {
        nome: false
      }
    }
  },
  methods:{
    isNomeValid() {
        /* eslint-disable-next-line */
        const re = /^(([a-z A-Z]{4,}))$/;

        this.validacoes.nome = re.test(this.nome) && this.nome
                        .trim()
                        .split(' ')
                        .length > 1;

        this.validacoes.nome ?
        this.$emit('validName', true) :
        this.$emit('validName', false)

        this.nome = this.nome.match(/[\p{Letter}\p{Mark}\s]+/gu).join('');

        this.$emit('NameField', this.nome)
      },
      enviaGA() {
      if(this.validacoes.nome){
        const pathLocation = window.location.pathname.replaceAll("/", "")
        dataLayer.push({
          event: 'customEvent',
          eventCategory: `blog: ${pathLocation}`,
          eventAction: 'preencheu:calculadora-custo-cnpj',
          eventLabel: `nome`
        })
      }
    },
  },
}
</script>
<style lang="scss" src="./style.scss" scoped></style>
